import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';

export default function MentionsLegales() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#0a0a0f] text-white min-h-screen">
      <Navbar scrolled={true} />
      
      <div className="pt-32 pb-20 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 bg-gradient-to-r from-violet-400 to-blue-400 bg-clip-text text-transparent">
            Mentions légales
          </h1>

          <div className="space-y-8 text-gray-300">
            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Éditeur du site</h2>
              <p className="mb-3">Le présent site internet est édité par :</p>
              <div className="bg-white/5 border border-white/10 rounded-lg p-6 space-y-2">
                <p><strong className="text-white">AI Exécutif Assistant</strong></p>
                <p>Entreprise individuelle : <strong className="text-white">Heuby Jennifer</strong></p>
                <p>Adresse du siège social : <strong className="text-white">50 avenue des Champs-Élysées, 75018 Paris, France</strong></p>
                <p>Numéro SIREN : <strong className="text-white">793 328 204</strong></p>
                <p>Immatriculée au RCS</p>
                <p>Directrice de la publication : <strong className="text-white">Madame Jennifer Heuby</strong></p>
                <p className="pt-3">📧 Email : <a href="mailto:contact@assistantexecutifai.com" className="text-violet-400 hover:text-violet-300 transition-colors">contact@assistantexecutifai.com</a></p>
                <p>📞 Téléphone : <a href="tel:+33970703990" className="text-violet-400 hover:text-violet-300 transition-colors">+33 9 70 70 39 90</a></p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Hébergement</h2>
              <p className="mb-3">Le site est hébergé par :</p>
              <div className="bg-white/5 border border-white/10 rounded-lg p-6 space-y-2">
                <p><strong className="text-white">Hostinger International Ltd</strong></p>
                <p>61 Lordou Vironos Street</p>
                <p>6023 Larnaca</p>
                <p>Chypre</p>
                <p>Site web : <a href="https://www.hostinger.com" target="_blank" rel="noopener noreferrer" className="text-violet-400 hover:text-violet-300 transition-colors">www.hostinger.com</a></p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Propriété intellectuelle</h2>
              <p>L'ensemble des contenus présents sur ce site (textes, images, logos, graphismes, icônes, vidéos, documents, structure générale) est la propriété exclusive de <strong className="text-white">AI Exécutif Assistant</strong>, sauf mention contraire.</p>
              <p className="mt-3">Toute reproduction, représentation, modification ou exploitation, totale ou partielle, sans autorisation écrite préalable est strictement interdite.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Données personnelles – RGPD</h2>
              <p className="mb-3">Les données personnelles collectées via les formulaires de contact ou de prise de rendez-vous sont utilisées exclusivement par <strong className="text-white">AI Exécutif Assistant</strong> dans le cadre de la relation commerciale.</p>
              <p className="mb-3">Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits d'accès, de rectification, d'effacement, de limitation, d'opposition et de portabilité de vos données.</p>
              <p>Pour exercer ces droits, vous pouvez contacter :</p>
              <p className="mt-2">📧 <a href="mailto:contact@assistantexecutifai.com" className="text-violet-400 hover:text-violet-300 transition-colors">contact@assistantexecutifai.com</a></p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Cookies</h2>
              <p>Le site peut utiliser des cookies afin d'améliorer l'expérience utilisateur, mesurer l'audience et optimiser les performances.</p>
              <p className="mt-3">Vous pouvez accepter, refuser ou paramétrer les cookies à tout moment via la bannière de consentement ou les paramètres de votre navigateur.</p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-4">Responsabilité</h2>
              <p>Les informations présentes sur ce site sont fournies à titre indicatif. <strong className="text-white">AI Exécutif Assistant</strong> ne saurait être tenue responsable des erreurs, omissions ou dommages directs ou indirects résultant de l'utilisation du site.</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}